import { FeedbackRequest } from "@/clients/models/FeedbackRequest";
import FilledButton from "@/components/button/filled-button";
import { PageContainer } from "@/components/container/page-container";
import { PageTitleComponent } from "@/components/page-title";
import { GO_TO_FEEDBACK_OPTIONS } from "@/constants/feedback";
import { useSendFeedback } from "@/hooks/requests/feedback/use-send-feedback";
import { useToast } from "@/hooks/ui/use-toast";
import { useIonRouter } from "@ionic/react";
import { useState } from "react";
import {
  FeedbackRadioGroup,
  ThankYouForFeedback,
} from "../../components/feedback-page";

export default function GoToFeedback() {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const { sendFeedback, isSendingFeedback } = useSendFeedback();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { showError, showSuccess } = useToast();
  const navigation = useIonRouter();

  const handleSubmit = () => {
    if (!selectedOption) {
      navigation.push("/plans/my-plan", "forward");
      return;
    }
    const option = GO_TO_FEEDBACK_OPTIONS.find(
      (option) => option.value === selectedOption,
    );
    const body: FeedbackRequest = {
      plan_setup: `${option?.value} - ${option?.title}`,
    };
    sendFeedback(body, {
      onSuccess: () => {
        setIsSubmitted(true);
        showSuccess("Thank you for your feedback!");
      },
      onError: () => {
        showError("Failed to submit feedback. Please try again.");
      },
    });
  };

  const handleOptionChange = (value: string) => {
    setSelectedOption(value);
  };

  return (
    <PageContainer
      className="app-bar-bottom-padding overflow-y-auto no-scrollbar"
      showLogo={true}
    >
      <PageTitleComponent
        title="Share your feedback (optional)"
        description="This won't affect your plan today."
      />

      {!isSubmitted ? (
        <div className="flex flex-col gap-4">
          <h6 className="text-lg font-medium text-gray-900">
            If you could choose, how would you prefer to set up your plan?
          </h6>

          <FeedbackRadioGroup
            selectedOption={selectedOption}
            handleOptionChange={handleOptionChange}
          />

          <div className="px-4 w-full">
            <FilledButton
              text={selectedOption ? "Submit Feedback" : "Skip"}
              color="dark"
              expand="full"
              shape="round"
              onClick={handleSubmit}
              disabled={isSendingFeedback}
            />
          </div>
        </div>
      ) : (
        <ThankYouForFeedback />
      )}
    </PageContainer>
  );
}
